import { lazyGetCopyToSections } from "owa-mail-ribbon-sections/lib/sections";
import type { MailRibbonTabId } from "owa-ribbon-ids/lib/mailRibbonId";
import type { ReadOnlyRibbonControlDefProps } from "owa-mail-ribbon-utils";
import type { MailboxInfo } from "owa-client-types";
import { setMenuDefinition } from "../../mutatorActions/setMenuDefinition";

export const onCopyToMenuClicked = (keytipTabId: MailRibbonTabId | undefined, props: ReadOnlyRibbonControlDefProps, mailboxInfo: MailboxInfo): void => {
    lazyGetCopyToSections.import().then(getCopyToSections => {
        setMenuDefinition("CopyToMenuDefinitionStore", props.projectionTabId, () => {
            return {
                sections: getCopyToSections(keytipTabId, props, mailboxInfo),
            };
        });
    });
};
